import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import {
  WALLET_FULL_ACCESS_ALERT_LINK_LABEL,
  WALLET_FULL_ACCESS_ALERT_TEXT_DEFAULT,
  WALLET_FULL_ACCESS_ALERT_TEXT_SANTANDER,
} from './wallet-full-access-alert.constants';

/**
 * Alerta reutilizável que direciona o usuário para acessar a versão completa
 * da sua carteira. Suporta 2 variações de texto:
 *
 *  - Nova experiência (`useNewExperience=true`): texto informativo sobre saldo Corretora vs Banco.
 *  - Experiência antiga (`useNewExperience=false`): CTA padrão para o app Santander Corretora.
 */
@Component({
  selector: 'tr-wallet-full-access-alert',
  templateUrl: './wallet-full-access-alert.component.html',
  styleUrls: ['./wallet-full-access-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalletFullAccessAlertComponent {
  @Input() public useNewExperience: boolean = false;

  @Output() public saibaMaisClicked = new EventEmitter<void>();

  public readonly linkLabel = WALLET_FULL_ACCESS_ALERT_LINK_LABEL;

  public get message(): string {
    return this.useNewExperience
      ? WALLET_FULL_ACCESS_ALERT_TEXT_SANTANDER
      : WALLET_FULL_ACCESS_ALERT_TEXT_DEFAULT;
  }

  public onSaibaMaisClick(): void {
    this.saibaMaisClicked.emit();
  }
}
